





















import Vue from "vue";
export default Vue.extend({
  name: "BlockLayout",
  props: {
    background: {
      type: String,
      required: false,
    },
    spacing: {
      type: String,
      required: false,
    },
    spacingTop: {
      type: String,
      required: false,
    },
    spacingBottom: {
      type: String,
      required: false,
    },
    hasContainer: {
      type: Boolean,
      required: false,
    },
  },
});
